import { graphql } from '../../graphql/generated';

export const PAGED_DOCTORS_QUERY = graphql(`
  query PagedDoctors($pageable: Pageable!, $filter: DoctorFilter!) {
    pagedDoctors(pageable: $pageable, filter: $filter) {
      totalCount
      entries {
        ...UpdateDoctorModal_Doctor
      }
    }
  }
`);

export const DOCTORS_META_QUERY = graphql(`
  query DoctorsMeta {
    labs {
      ...DoctorForm_Lab
    }

    catalogs {
      ...DoctorForm_Catalog
    }

    insurances {
      ...DoctorForm_Insurance
    }

    specialRates {
      ...DoctorForm_SpecialRate
    }

    themes {
      ...DoctorForm_Theme
    }

    tags {
      ...DoctorForm_Tag
    }

    allDoctorMeAddresses
  }
`);
